import { downloadWORDFile, getAxiosConfigUserToken } from "app/utils/appHelpers";
import axios from "axios";
import config from "config";


export const getReportListByMeetingIdWORDApi = async (meetingId, type, fileName) => {

    const url = `${config.apiUrl}/v1/word/reportList/${meetingId}/${type}/${fileName}`;
    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/octet-stream' });

            downloadWORDFile(file, fileName)


        });
}

export const getOneRecordByIdWORDApi = async (meetingId, decisionId, type, fileName) => {


    const url = `${config.apiUrl}/v1/word/oneRecord/${meetingId}/${decisionId}/${type}`;

    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/octet-stream' });

            downloadWORDFile(file, fileName)
        });
}

export const getUsersByMeetingIdWORDFApi = async (meetingId, type, fileName) => {


    const url = `${config.apiUrl}/v1/word/meetingUsers/${meetingId}/${type}`;

    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/octet-stream' });

            downloadWORDFile(file, fileName)
        });
}




export const getForEachDecisionByMeetingIdWORDApi = async (meetingId, fileName = "Tek Karar İmza Belirli") => {


    const url = `${config.apiUrl}/v1/word/eachDecision/${meetingId}`;

    return axios.get(url, {
        method: 'GET',
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/octet-stream' });

            downloadWORDFile(file, fileName)
        });
}




export const getUnclearSignatureWORDApi = async (meetingId, fullName, position) => {
    const url = `${config.apiUrl}/v1/word/unclearSignature/${meetingId}`;
    return axios
        .get(url, {
            method: 'GET',
            responseType: 'blob',
            params: { fullName, position },
            ...getAxiosConfigUserToken(),
        })
        .then(response => {
            const file = new Blob(
                [response.data],
                { type: 'application/octet-stream' });

            downloadWORDFile(file, "Tek Tek Kararlar İmza Belirsiz")
        });
};


